import React, { useState, useEffect } from 'react';
import { Timer, WebLiveCapture } from '../../components';
import devtools from '../../../node_modules/devtools-detect/index.js';
import putObject from '../../utils/upload_ali';
import putObjectToR2 from '../../utils/upload_to_r2';
import { CtaButton } from '../../components';
import './exam.css';

import { message } from 'antd';

const Exam = ({
  // examName = 'Periodic Test - DBMS: 20th January, 2022',
  // studentID = '1902112',
  // studentEmail = 'tusharnankani3@gmail.com',
  // formLink = 'https://docs.google.com/forms/d/e/1FAIpQLSdW6xfghZ9Nz59YkDt68-_giTO3mzcfDlkGZlA7HFWBCU7O7A/viewform?usp=sf_link'
}) => {
	const [isStartExam, setIsStartExam] = useState(false);
	const [isShowLogin, setIsShowLogin] = useState(false);
	const [isMultipleScreen, setIsMultipleScreen] = useState(false);
  const [warningCnt, setWarningCnt] = useState(0);
  const [isDevToolsOpen, setIsDevToolsOpen] = useState(false);
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [showMessage, setShowMessage] = useState('');
	const [proctor, setProctor] = useState(null)
	const [duration, setDuration] = useState(0)
	const [startTime, setStartTime] = useState(0)
	const [endTime, setEndTime] = useState(0)
	const [user, setUser] = useState(null)
	const [examId, setExamId] = useState('')
	const [examName, setExamName] = useState('')
	const [formLink, setFormLink] = useState('')
	const [isTimerFinished, setIsTimerFinished] = useState(false)
	// 添加轮询loading状态
	const [isPollingLoading, setIsPollingLoading] = useState(false);
	const [pollingLoadingText, setPollingLoadingText] = useState('');
	// 添加录制状态 - 使用 ref 而不是 state 来避免闭包问题
	const screenRecorderRef = React.useRef(null);
	const cameraRecorderRef = React.useRef(null);
	const screenChunksRef = React.useRef([]);
	const cameraChunksRef = React.useRef([]);
	// 上传状态
	const [isUploading, setIsUploading] = useState(false);
	const [uploadProgress, setUploadProgress] = useState({ screen: 0, camera: 0 });
	const [uploadStatus, setUploadStatus] = useState('');

	// Loading组件
	const PollingLoading = ({ isVisible, text }) => {
		if (!isVisible) return null;
		
		return (
			<div className="fixed inset-0 h-screen w-full flex justify-center items-center bg-black bg-opacity-70 z-50">
				<div className="flex flex-col items-center">
					<div className="animate-spin rounded-full h-12 w-12 border-b-2 border-white mb-4"></div>
					<p className="text-white text-lg">{text}</p>
				</div>
			</div>
		);
	};
	
	// 上传进度组件
	const UploadProgress = ({ isVisible, status, progress }) => {
		if (!isVisible) return null;
		
		return (
			<div className="fixed inset-0 h-screen w-full flex justify-center items-center bg-black bg-opacity-80 z-50">
				<div className="bg-white rounded-lg p-8 max-w-md w-full mx-4">
					<div className="flex flex-col items-center">
						<svg className="w-16 h-16 text-green-500 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
							<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
						</svg>
						<h2 className="text-2xl font-semibold text-gray-800 mb-2">Exam Completed!</h2>
						<p className="text-gray-600 text-center mb-6">{status}</p>
						
						{(progress.screen > 0 || progress.camera > 0) && (
							<div className="w-full space-y-4">
								{progress.screen > 0 && (
									<div>
										<div className="flex justify-between text-sm text-gray-600 mb-1">
											<span>Screen Recording</span>
											<span>{progress.screen}%</span>
										</div>
										<div className="w-full bg-gray-200 rounded-full h-2.5">
											<div className="bg-blue-600 h-2.5 rounded-full transition-all duration-300" style={{width: `${progress.screen}%`}}></div>
										</div>
									</div>
								)}
								{progress.camera > 0 && (
									<div>
										<div className="flex justify-between text-sm text-gray-600 mb-1">
											<span>Camera Recording</span>
											<span>{progress.camera}%</span>
										</div>
										<div className="w-full bg-gray-200 rounded-full h-2.5">
											<div className="bg-green-600 h-2.5 rounded-full transition-all duration-300" style={{width: `${progress.camera}%`}}></div>
										</div>
									</div>
								)}
							</div>
						)}
						
						{!status.includes('failed') && status.includes('...') && (
							<div className="mt-4">
								<div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
							</div>
						)}
					</div>
				</div>
			</div>
		);
	};

	useEffect(() => {
		getUserStatus()

		const href = window.location.pathname
		const index = href.lastIndexOf('/')
		const key = href.substring(index + 1) 
		// const key = '660cf680aa81eb68281b66eb'
		if (key) {
			setExamId(key)
			getSettings(key).then((res) => {
				console.log('res', res)
				const { proctor, formId, formName, formUrl, duration } = JSON.parse(res.data.value)
				console.log('proctor', proctor)
				console.log('formUrl', formUrl)
				setProctor(proctor)
				setExamName(formName)
				setFormLink(formUrl)
				setDuration(duration.minutes)
				setStartTime(duration.startTime)
				setEndTime(duration.endTime)
			}).catch((err) => {
				console.log('err', err)
			})
		}
	}, [])

  useEffect(() => {
		if (!isStartExam) return;

    const handleDevToolsChange = (event) => {
      setIsDevToolsOpen(event.detail.isOpen);
      if (event.detail.isOpen) {
        setWarningCnt((prevCount) => prevCount + 1);
        setShowMessage('Your exam will terminate. Please close devtools.');
        disableForm();
      }
    };

    window.addEventListener('devtoolschange', handleDevToolsChange);

		let exitFullscreenCount = 0;
		const handleFullscreenChange = (event) => {
			if (!document.fullscreenElement) {
				console.log('已退出全屏模式');
				saveExamProctorData({
					type: 'not_full_screen',
					count: exitFullscreenCount++
				})
			}
		};

		// 添加事件监听器来监听全屏变化事件
		document.addEventListener('fullscreenchange', handleFullscreenChange);


    const fullscreenCheckInterval = setInterval(check, 10000);
    const captureCheckInterval = setInterval(captureCheck, 60000);

		//每隔一分钟截取一张图片
		let imageCaptureInterval = null;
		if (window.g_screenStream && proctor && proctor.isCaptureScreen) {
			const imageCapture = new ImageCapture(window.g_screenStream.getVideoTracks()[0]);
			imageCaptureInterval = setInterval(() => {
				imageCapture.grabFrame().then((imageBitmap) => {
					console.log('imageBitmap', imageBitmap);
					examScreen(imageBitmap)
				}).catch((error) => {})
			}, 60000)
		}

    // Cleanup function
    return () => {
      window.removeEventListener('devtoolschange', handleDevToolsChange);
			document.removeEventListener('fullscreenchange', handleFullscreenChange);
      clearInterval(fullscreenCheckInterval);
      clearInterval(captureCheckInterval);
			if (imageCaptureInterval) clearInterval(imageCaptureInterval);
    };
  }, [isStartExam]); // Empty dependency array means this effect runs only on mount and unmount

  useEffect(() => {
    // Only disable or enable form based on current state to prevent unnecessary re-renders
    if (isDevToolsOpen || !isFullScreen || warningCnt > 5) {
      disableForm();
    } else {
      enableForm();
    }
    // Check for termination condition
    if (warningCnt > 5) {
      terminateExam();
    }
  }, [isDevToolsOpen, isFullScreen, warningCnt]); // This effect depends on these states

	async function getUserStatus() {
		//post请求 https://www.livepolls.app/exam_proctor/api/user/status，"Content-Type"为"application/x-www-form-urlencoded; charset=UTF-8"，参数为app_type
		const response = await fetch('https://www.livepolls.app/exam_proctor/api/user/status', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
				'X-Access-Channel': 'exam_proctor'
			},
			body: 'app_type=' + (window.app_type || 'web')
		});

		const status = await response.json();
		console.log('status', status);
		if (status.data) {
			const { profile, subscription, team_subscription } = status.data;
			if (profile) {
        let { free_cnt, is_subscribed, detail } = subscription;
        if (!free_cnt) free_cnt = 0;
        if (detail && detail.ends_at) is_subscribed = new Date(detail.ends_at) > new Date();
        if (team_subscription && team_subscription.detail) is_subscribed = true;
        const subscribedType = is_subscribed && (detail && detail.name || team_subscription && team_subscription.detail && team_subscription.detail.name) || '';
        const _user = { ...profile, free_cnt, is_subscribed, subscribedType };
				setUser(_user);
        window.userStatus = _user;
      }
		}

		return user;
	}

	//post请求 https://usa.imgkits.com/node-api/exam，参数为type和image
	const examScreen = async (imageBitmap) => {
		const canvas = document.createElement('canvas');
		canvas.width = imageBitmap.width * 0.5;
		canvas.height = imageBitmap.height * 0.5;
		canvas.getContext('2d').drawImage(imageBitmap, 0, 0);
		const base64 = canvas.toDataURL('image/jpeg', 0.8).replace(/^data:image\/\w+;base64,/, '');
		const blob = new Blob([ new Uint8Array(atob(base64).split('').map((c) => c.charCodeAt(0))) ], { type: 'image/jpeg' });
		const file = new File([ blob ], 'test.jpeg', { type: 'image/jpeg' });
		const image = await putObject(file, 'exam_proctor_', 'californian');
		console.log('putObject', image);

		if (image.url) {
			const response = await fetch('https://usa.imgkits.com/node-api/exam', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify({ type: 0, image: image.url.replace('https', 'http') }),
			});
			const res = await response.json();
			console.log('examScreen', res);
			if (res.data && res.data.statusCode === 200) {
				const data = res.data.body.data;
				if (data.chatScore > data.threshold) {
					const saveData = {
						type: 'detecte_screen',
						image: image.url,
						time: new Date().getTime()
					};
					saveExamProctorData(saveData);
				}
			}
		}
	}

  const captureCheck = () => {
    let btn = document.querySelector('#root > div > div > div.left-column > div.image-capture > button');
    btn.click();
  };

  const check = () => {
    const currentIsFullScreen = judgeIsFullScreen();
    if (!currentIsFullScreen) {
      setWarningCnt((prevCount) => prevCount + 1);
      setShowMessage('Your exam will terminate. Please go to full screen mode.');
    }
    setIsFullScreen(currentIsFullScreen);
  };

  const judgeIsFullScreen = () => document.fullscreenElement != null;

  const disableForm = () => {
    let overlay = document.getElementById('overlay');
    let formBlur = document.getElementById('form-blur');
    overlay?.classList.remove('hide');
    overlay?.classList.add('disable');
    formBlur?.classList.add('blur');
  };

  const enableForm = () => {
    let overlay = document.getElementById('overlay');
    let formBlur = document.getElementById('form-blur');
    overlay?.classList.add('hide');
    overlay?.classList.remove('disable');
    formBlur?.classList.remove('blur');
  };

  const terminateExam = () => {
    let overlay = document.getElementById('overlay');
    overlay?.classList.add('terminate');
  };

	//检查 multiple screens
	function checkMultipleScreen() {
		return window.screen.isExtended;
	}

  // Add remaining component logic here as needed
	function enterFullScreen() {
		if (document.documentElement.requestFullscreen) {
			document.documentElement.requestFullscreen();
		} else if (document.documentElement.mozRequestFullScreen) { /* Firefox */
			document.documentElement.mozRequestFullScreen();
		} else if (document.documentElement.webkitRequestFullscreen) { /* Chrome, Safari 和 Opera */
			document.documentElement.webkitRequestFullscreen();
		} else if (document.documentElement.msRequestFullscreen) { /* IE/Edge */
			document.documentElement.msRequestFullscreen();
		}
		setIsFullScreen(judgeIsFullScreen());
	}

	async function enterExam() {
		setIsStartExam(true);
		enterFullScreen();

		try {
			const res = await getSettings(examId);
			const data = JSON.parse(res.data.value);
			const examinees = data.examinees || [];
			const hasSaved = examinees.find(examinee => examinee.id === user.id);
			if (!hasSaved) {
				const startTime = new Date().getTime();
				examinees.push({ id: user.id, name: user.username, email: user.email, startTime });
				data.examinees = examinees;
				saveSettings(examId, JSON.stringify(data));

				saveExamProctorData({
					type: 'exam_started',
					startTime
				})
			}
		} catch (error) {
			
		}
	}

	function captureScreen() {
		let constraints = { 
			video: { 
				width: 800,
				height: window.innerHeight / window.innerWidth * 800
			}
		}
		// if (devices.audioDeviceId && !devices.isCloseAudioDevice) constraints.audio = { deviceId: devices.audioDeviceId };
	
		return new Promise((resolve, reject) => {
			if (navigator.getDisplayMedia) {
				navigator.getDisplayMedia(constraints).then(stream => {
					resolve(stream);
				}).catch((error) => {
					reject(error);
				})
			} else if (navigator.mediaDevices.getDisplayMedia) {
				navigator.mediaDevices.getDisplayMedia(constraints).then(stream => {
					resolve(stream);
				}).catch((error) => {
					reject(error);
				})
			} else {
				reject('getDisplayMedia API are not supported in this browser.');
			}
		})
	}

	async function handleRecordScreen() {
		const screenStream = await captureScreen();
		window.g_screenStream = screenStream;
		
		// 开始录制屏幕
		if (proctor && proctor.isCaptureScreen) {
			try {
				let mimeType = 'video/webm;codecs=vp9';
				if (!MediaRecorder.isTypeSupported(mimeType)) {
					mimeType = 'video/webm';
				}
				
				const recorder = new MediaRecorder(screenStream, { mimeType });
				screenChunksRef.current = [];
				
				recorder.ondataavailable = (e) => {
					if (e.data.size > 0) {
						screenChunksRef.current.push(e.data);
					}
				};
				
				recorder.start(10000); // 每10秒保存一次数据
				screenRecorderRef.current = recorder;
				console.log('Screen recording started');
			} catch (error) {
				console.error('Failed to start screen recording:', error);
			}
		}
	}

	function enumerateDevices() {
		return new Promise((resolve, reject) => {
			navigator.mediaDevices.enumerateDevices()
			.then(function(device) {
				console.log('device', device);
				resolve(device);
			}).catch(function(err) {
				console.log('err', err);
				reject(err);
			});
		})
	}
		
	function getUserMedia() {
		return new Promise((resolve, reject) => {
			navigator.mediaDevices.getUserMedia({ audio: true, video: true })
					.then((stream) => {
						// 开始录制摄像头
						if (proctor && proctor.isFaceDetection) {
							try {
								let mimeType = 'video/webm;codecs=vp9';
								if (!MediaRecorder.isTypeSupported(mimeType)) {
									mimeType = 'video/webm';
								}
								
								const recorder = new MediaRecorder(stream, { mimeType });
								cameraChunksRef.current = [];
								
								recorder.ondataavailable = (e) => {
									if (e.data.size > 0) {
										cameraChunksRef.current.push(e.data);
									}
								};
								
								recorder.start(10000); // 每10秒保存一次数据
								cameraRecorderRef.current = recorder;
								window.g_cameraStream = stream;
								console.log('Camera recording started');
							} catch (error) {
								console.error('Failed to start camera recording:', error);
							}
						}
						resolve(stream);
					})
					.catch((err) => {
						let errorMessage = '';
						if (err.name === 'NotFoundError' || err.name === 'DevicesNotFoundError') {
							errorMessage = 'Camera device not found. Please ensure your camera is connected and try again, or use another device to start the exam.';
						} else if (err.name === 'NotAllowedError' || err.name === 'PermissionDeniedError') {
							errorMessage = 'Camera permission denied. Please grant camera access in your browser settings and try again.';
						} else if (err.name === 'NotReadableError' || err.name === 'TrackStartError') {
							errorMessage = 'Camera is already in use by another application. Please close other applications and try again.';
						} else {
							errorMessage = `Camera access error: ${err.message}. Please check your device and try again.`;
						}
						reject({ error: err, message: errorMessage });
					})
		})
	}

	async function startExam() {
		if (!examId) {
			alert('Invalid exam id');
			return;
		}

		if (startTime && new Date() < new Date(startTime)) {
			message.warning('Exam starts at ' + new Date(startTime).toLocaleString());
			return;
		} else if (endTime && new Date() > new Date(endTime)) {
			message.warning('Exam has ended at ' + new Date(endTime).toLocaleString());
			return;
		}

		if (!user) {
			setIsShowLogin(true);
			return;
		}

		if  (proctor && proctor.isFaceDetection) {
			try {
				await getUserMedia();
			} catch (err) {
				const errorMsg = err.message || 'Camera access failed. Please check your device and permissions.';
				message.error(errorMsg, 6);
				console.error('getUserMedia error:', err);
				return;
			}
		}

		if (proctor && proctor.isCaptureScreen) {
			try {
				await handleRecordScreen();
			} catch (err) {
				message.error('Screen capture failed. Please grant screen sharing permission and try again.', 6);
				console.error('handleRecordScreen error:', err);
				return;
			}
		}

		if (checkMultipleScreen()) {
			setIsMultipleScreen(true);
			return;
		}

		enterExam();
	}

	function continueWithMonitors() {
		setIsMultipleScreen(false);
		enterExam();

		saveExamProctorData({
			type: 'multiple_screen',
		})
	}

	function completeExam() {
		setIsStartExam(false);	
	}

	function getSettings(key) {
		return new Promise((resolve, reject) => {
			const formData = new URLSearchParams();
			formData.append('key', key);

			fetch('https://www.livepolls.app/site/get', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
				},
				body: formData.toString()
			})
				.then(res => res.json())
				.then(res => {
					console.log('getSettings', res)
					resolve(res)
				})
				.catch(err => {
					console.log('getSettings err', err)
					reject(err)
				})
		})
  }

	function saveSettings(key, value) {
		const params = new URLSearchParams();
		params.append('key', key);
		params.append('value', value);
		params.append('persistence', '1');

		return fetch('https://www.livepolls.app/site/save', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded'
			},
			body: params.toString()
		})
			.then(res => res.json())
			.then(res => {
				console.log('saveSettings', res);
				return res;
			})
			.catch(err => {
				console.log('saveSettings err', err);
				throw err;
			});
	}

	async function saveExamProctorData(data) {
		try {
			const key = examId + '-' + user.id;
			const res = await getSettings(key);
			if (res && res.message != 'the value is empty') {
				const value = JSON.parse(res.data.value);
				const detecteData = value.detecteData || [];

				if (data.type == 'exam_started') {
					value.startTime = data.startTime;
					await saveSettings(key, JSON.stringify(value));
				} else if (data.type == 'exam_finished') {
					value.endTime = data.endTime;
					value.usedMinutes = data.usedMinutes;
					// 保存录制视频的URL
					if (data.recordings) {
						value.recordings = data.recordings;
					}
					// 保存上传错误信息（如果有）
					if (data.uploadError) {
						value.uploadError = data.uploadError;
					}
					await saveSettings(key, JSON.stringify(value));
				} else if (data.type == 'multiple_screen') {
					if (!detecteData.find(item => item.type == 'multiple_screen')) {
						detecteData.push(data);
						value.detecteData = detecteData;
						await saveSettings(key, JSON.stringify(value));
					}
				} else if (data.type == 'not_full_screen') {
					const index = detecteData.findIndex(item => item.type == 'not_full_screen');
					if (index > -1) {
						detecteData[index].count = data.count;
					} else {
						detecteData.push(data);
					}
					value.detecteData = detecteData;
					await saveSettings(key, JSON.stringify(value));
				} else {
					detecteData.push(data);
					value.detecteData = detecteData;
					await saveSettings(key, JSON.stringify(value));
				}
			} else {
				const value = { detecteData: [data] };
				await saveSettings(key, JSON.stringify(value));
			}
		} catch (error) {
			
		}
	}

	async function handleFinish(usedMinutes) {
		setIsStartExam(false);
		setIsTimerFinished(true);
		setIsUploading(true);
		setUploadStatus('Exam completed! Uploading your exam recordings...');
		
		try {
			const uploadUrls = {};
			
			// 停止并上传屏幕录制
			const screenRecorder = screenRecorderRef.current;
			if (screenRecorder && screenRecorder.state !== 'inactive') {
				setUploadStatus('Processing screen recording...');
				await new Promise((resolve) => {
					screenRecorder.onstop = resolve;
					screenRecorder.stop();
				});
				
				if (screenChunksRef.current.length > 0) {
					const screenBlob = new Blob(screenChunksRef.current, { type: 'video/webm' });
					const screenFile = new File([screenBlob], 'screen-recording.webm', { type: 'video/webm' });
					
					setUploadStatus('Uploading screen recording...');
					const screenUpload = await putObjectToR2(
						screenFile,
						'screen-recording.webm',
						'exam_proctor',
						'exam_screen_',
						'video',
						(progress) => {
							if (progress.total > 0) {
								const percent = Math.round((progress.loaded / progress.total) * 100);
								setUploadProgress(prev => ({ ...prev, screen: percent }));
							}
						}
					);
					
					if (screenUpload.url) {
						uploadUrls.screenRecording = screenUpload.url;
					}
				}
			}
			
			// 停止并上传摄像头录制
			const cameraRecorder = cameraRecorderRef.current;
			if (cameraRecorder && cameraRecorder.state !== 'inactive') {
				setUploadStatus('Processing camera recording...');
				await new Promise((resolve) => {
					cameraRecorder.onstop = resolve;
					cameraRecorder.stop();
				});
				
				if (cameraChunksRef.current.length > 0) {
					const cameraBlob = new Blob(cameraChunksRef.current, { type: 'video/webm' });
					const cameraFile = new File([cameraBlob], 'camera-recording.webm', { type: 'video/webm' });
					
					setUploadStatus('Uploading camera recording...');
					const cameraUpload = await putObjectToR2(
						cameraFile,
						'camera-recording.webm',
						'exam_proctor',
						'exam_camera_',
						'video',
						(progress) => {
							if (progress.total > 0) {
								const percent = Math.round((progress.loaded / progress.total) * 100);
								setUploadProgress(prev => ({ ...prev, camera: percent }));
							}
						}
					);
					
					if (cameraUpload.url) {
						uploadUrls.cameraRecording = cameraUpload.url;
					}
				}
			}
			
			// 停止所有流
			if (window.g_screenStream) {
				window.g_screenStream.getTracks().forEach(track => track.stop());
			}
			if (window.g_cameraStream) {
				window.g_cameraStream.getTracks().forEach(track => track.stop());
			}
			
			// 保存考试数据，包含录制视频URL
			setUploadStatus('Saving exam data...');
			await saveExamProctorData({
				type: 'exam_finished',
				usedMinutes,
				endTime: new Date().getTime(),
				recordings: uploadUrls
			});
			
			setUploadStatus('Upload completed successfully!');
			setTimeout(() => {
				setIsUploading(false);
			}, 2000);
			
		} catch (error) {
			console.error('Error uploading recordings:', error);
			setUploadStatus('Upload failed. Please contact administrator.');
			
			// 即使上传失败也要保存基本的考试完成数据
			await saveExamProctorData({
				type: 'exam_finished',
				usedMinutes,
				endTime: new Date().getTime(),
				uploadError: error.message
			});
			
			setTimeout(() => {
				setIsUploading(false);
			}, 3000);
		}
	}
	

	var windowOpener = null;
	function login() {
		setIsShowLogin(false);
		windowOpener = window.open('https://www.livepolls.app/exam_proctor/login', '_blank');
		startPollingUserStatus('login');
	}

	let isPollingRefresh = false;
	let pollingCounter = 1;
	let errorCounter = 0;
	let hasSetLoadingText = false;

	/**
	 * 刷新用户状态
	 * @param {string} type - login | subscribed | loginAndSubscribed
	 * @param {boolean} isPolling - 是否为轮询请求
	*/
	function refreshUserStatus(type, isPolling = false) {
		if (isPollingRefresh) {
			return;
		} else {
			isPollingRefresh = true;
		}

		pollingCounter++;
		getUserStatus().then(() => {
			isPollingRefresh = false;
			if (type == 'login') {
				if (user) {
					message.success('Login successful, please continue～');
					setIsPollingLoading(false); // 关闭loading
				} else {
					if (isPolling) {
						setTimeout(() => {
							pollingUserStatus(type);
						}, 5000)
					}
				}
			} else if (type == 'subscribed') {
				if (user && user.is_subscribed) {
					message.success('Subscribe successful, please continue～');
					setIsPollingLoading(false); // 关闭loading
				} else {
					if (isPolling) {
						setTimeout(() => {
							pollingUserStatus(type);
						}, 5000)
					}
				}
			} else if (type == 'loginAndSubscribed') {
				if (user && user.is_subscribed) {
					message.success('Subscribe successful, please continue～');
					setIsPollingLoading(false); // 关闭loading
				} else {
					if (user && !user.is_subscribed && !hasSetLoadingText) {
						console.log('subscribing...');
						console.log('user', user);
						hasSetLoadingText = true;
						setPollingLoadingText('subscribing...'); // 更新loading文本
					}

					if (isPolling) {
						setTimeout(() => {
							pollingUserStatus(type);
						}, 5000)
					}
				}
			}
		}, (err) => {
			isPollingRefresh = false;
			if (errorCounter < 3) {
				if (isPolling) {
					setTimeout(() => {
						pollingUserStatus(type);
					}, 5000)
				}
			} else {
				message.error(err);
				setIsPollingLoading(false); // 关闭loading
			}
			errorCounter++;
		})
	}

	/**
	 * 轮询用户状态
	 * @param {string} type - login | subscribed | loginAndSubscribed
	*/
	function pollingUserStatus(type) {
		console.log('windowOpener', windowOpener);
		if (!windowOpener || windowOpener.closed) {
			if (type == 'login') {
				if (!user) {
					refreshUserStatus(type);
				}
			} else {
				if (!user || !user.is_subscribed) {
					refreshUserStatus(type);
				}
			}
			windowOpener = null;
			setIsPollingLoading(false); // 关闭loading
			return;
		} else if (pollingCounter > 40) {
			windowOpener = null;
			setIsPollingLoading(false); // 关闭loading
			return;
		}
		refreshUserStatus(type, true);
	}

	/**
	 * 开始轮询用户状态
	 * @param {string} type - login | subscribed | loginAndSubscribed
	*/
	async function startPollingUserStatus(type) {
		pollingCounter = 1;
		errorCounter = 0;
		hasSetLoadingText = false;
		console.log('type', type);
		
		// 显示loading
		setIsPollingLoading(true);
		setPollingLoadingText(type == 'subscribed' ? 'subscribing...' : 'logining...');

		setTimeout(() => {
			pollingUserStatus(type);
		}, 6000)
	}

  return (
		<>
			{/* 轮询Loading */}
			<PollingLoading isVisible={isPollingLoading} text={pollingLoadingText} />
			
			{/* 上传进度 */}
			<UploadProgress isVisible={isUploading} status={uploadStatus} progress={uploadProgress} />
			
		  {
				isStartExam ? (
					<div className="exam-container">
						<div className="left-column">
							{/* default hidden */}
							{
								proctor && proctor.isFaceDetection && (
									<div className="image-capture">
										<WebLiveCapture onSaveData={(data) => saveExamProctorData(data)} />
									</div>
								)
							}
							<div className="exam-details">
								<h3 className="title-heading">Candidate details</h3>

								<div className="details">
									<h4 className="student-id">Candidate ID: {user && user.id}</h4>
									<h4 className="student-email">
										Candidate Email: {user && user.email}
									</h4>
								</div>
							</div>
						</div>

						<div className="embedded-form">
							{/* add disable to class, remove hide */}
							<div className="hide" id="overlay">
								<h2>Message: {showMessage}</h2>
								<h2>Warnings: {warningCnt}</h2>

								<h1>Exam Terminated</h1>
								<h3>Please contact your organization/admin.</h3>
								{
									!isFullScreen && (
										<div className="mt-5" onClick={enterExam}>
											<CtaButton text="Enter Fullscreen" />
										</div>
									)
								}
							</div>

							{/* add blur to class */}
							<div className="form" id="form-blur">
								<h2 className="title-heading">{examName}</h2>
								<iframe
									title={examName}
									className="form-link"
									src={formLink}
								>
									Form
								</iframe>

								<div className="responsive-message">
									<h1>
										Please join via a Laptop/PC for best performance
									</h1>
								</div>
							</div>
						</div>

						<div>
							<Timer initialMinute={duration} onFinish={handleFinish} />
						</div>
					</div>
				) : (
					<div className="flex-center full-screen-height">
						{isTimerFinished ? (
							<div className="text-center">
								<h1 className="text-2xl font-semibold">Exam Finished</h1>
								<p className="text-gray-500 mt-2">Thank you for taking the exam</p>
							</div>
						) : (
							<div className="p-5">
								<h1 className="text-xl font-semibold">Before you start the test</h1>
								<div className="mt-2 mb-4">
									{/* <p className="text-sm text-gray-500">Please complete the test on time.</p> */}
									<ul className="mt-4">
										<li className="text-sm mb-2 flex items-center">
											<svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" className="mr-2 text-lg" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
												<path fill="none" d="M0 0h24v24H0V0z"></path>
												<path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm3.3 14.71L11 12.41V7h2v4.59l3.71 3.71-1.42 1.41z"></path>
											</svg>
											<span>This is a time bound test and the duration is <b className="ml-1"> {duration} minutes</b>. Please complete the test on time.</span>
										</li>
										{
											proctor && proctor.isCaptureScreen && (
												<li className="text-sm mb-2 flex items-center">
													<svg stroke="currentColor" fill="currentColor" viewBox="0 0 576 512" className="mr-2 text-lg" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M528 0H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h192l-16 48h-72c-13.3 0-24 10.7-24 24s10.7 24 24 24h272c13.3 0 24-10.7 24-24s-10.7-24-24-24h-72l-16-48h192c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zm-16 352H64V64h448v288z"></path></svg>
													<span>We will be monitoring your screen during the test.</span>
												</li>
											)
										}
										{
											proctor && proctor.isFaceDetection && (
												<li className="text-sm mb-2 flex items-center">
													<svg stroke="currentColor" fill="currentColor" viewBox="0 0 16 16" className="mr-2 text-lg" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M15 12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h1.172a3 3 0 0 0 2.12-.879l.83-.828A1 1 0 0 1 6.827 3h2.344a1 1 0 0 1 .707.293l.828.828A3 3 0 0 0 12.828 5H14a1 1 0 0 1 1 1v6zM2 4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-1.172a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 9.172 2H6.828a2 2 0 0 0-1.414.586l-.828.828A2 2 0 0 1 3.172 4H2z"></path><path d="M8 11a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5zm0 1a3.

5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7zM3 6.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0z"></path></svg>
													<span>Your front camera will be used to monitor you during the test.</span>
												</li>
											)
										}
										<li className="text-sm mb-2 flex items-center">
											<svg stroke="currentColor" fill="currentColor" viewBox="0 0 576 512" className="mr-2 text-lg" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M528 0H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h192l-16 48h-72c-13.3 0-24 10.7-24 24s10.7 24 24 24h272c13.3 0 24-10.7 24-24s-10.7-24-24-24h-72l-16-48h192c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zm-16 352H64V64h448v288z"></path></svg>
											You are not allowed to leave the test screen before submitting the test.
										</li>
									</ul>
								</div>
								<div className="mt-8 text-center" onClick={startExam}>
									<CtaButton text="Start Exam" />
								</div>
							</div>
						)}
					</div>
				)
			}

			{
				isMultipleScreen && (
					<div className="fixed inset-0 h-screen w-full flex justify-center items-center bg-black bg-opacity-60">
						<div className="mx-2 w-[700px] p-6 sm:p-10 flex flex-col bg-white text-gray-700 rounded-lg">
							<div>
								<h1 className="text-lg font-semibold">Multiple Monitor Detected</h1>
								<p className="text-sm text-gray-500 mt-2">We have detected multiple screens. Please disconnect the extra monitor (or devices like Chromecast). If you continue without disconnecting, we will store details of the device. Continue with monitor only if it's necessary</p>
							</div>
							<div className="flex flex-col sm:flex-row mt-6">
								<button className="w-full bg-gray-300 text-gray-700 py-2 px-4 rounded-lg mb-2 sm:mb-0 sm:mr-4" onClick={continueWithMonitors}>Continue with monitors</button>
								<button className="w-full bg-[#9a6afd] text-white py-2 px-4 rounded-lg" style={{background: '#5880f0'}} onClick={startExam}>I'll disconnect the monitor</button>
							</div>
						</div>
					</div>
				)
			}

			{
				isShowLogin && (
					<div className="fixed inset-0 h-screen w-full flex justify-center items-center bg-black bg-opacity-60">
						<div className="mx-2 w-[400px] p-6 sm:p-10 flex flex-col bg-white text-gray-700 rounded-lg">
							<div>
								<h1 className="text-lg font-semibold">Tips</h1>
								<p className="text-sm text-gray-500 mt-2">Please login to start the exam</p>
							</div>
							<div className="flex flex-col sm:flex-row mt-6">
								<button className="w-full bg-gray-300 text-gray-700 py-2 px-4 rounded-lg mb-2 sm:mb-0 sm:mr-4" onClick={() => setIsShowLogin(false)}>Cancel</button>
								<button className="w-full bg-[#9a6afd] text-white py-2 px-4 rounded-lg" style={{background: '#5880f0'}} onClick={login}>Login</button>
							</div>
						</div>
					</div>
				)
			}
		</>
  );
};

export default Exam;